export enum DEBUGGER_TAB_KEYS {
  DATASOURCE_TAB = "DATASOURCE_TAB",
  RESPONSE_TAB = "RESPONSE_TAB",
  HEADER_TAB = "HEADERS_TAB",
  ERROR_TAB = "ERROR_TAB",
  LOGS_TAB = "LOGS_TAB",
  INSPECT_TAB = "INSPECT_TAB",
}
